import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

export const Divider = styled.div`
  border-top: ${borders.standard};
  margin: 0rem 1.714rem;
`;

export const FullDivider = styled.div`
  border-top: ${borders.standard};
`;
